export default __webpack_public_path__ + "static/media/teams.57c05529.mp4";